export type LoopbackHost = '127.0.0.1' | 'localhost' | '::1';

const loopbackHosts: readonly string[] = ['127.0.0.1', 'localhost', '::1'];

/** Shared parser for feature adapters that accept only local Firebase emulators. */
export function firebaseEmulatorEndpoint(
  value: string | boolean | undefined,
  fallbackPort: number,
  hostError: string,
  portError?: string,
) {
  const [host, portText] = String(value || `127.0.0.1:${fallbackPort}`)
    .replace(/^https?:\/\//u, '')
    .split(':');
  if (!loopbackHosts.includes(host ?? '')) throw new Error(hostError);
  const port = Number(portText ?? fallbackPort);
  if (portError && (!Number.isInteger(port) || port < 1 || port > 65_535))
    throw new Error(portError);
  return { host: host as LoopbackHost, port };
}
